export const KPI_HISTORY = 'kpi_history';
export const types = { [KPI_HISTORY]: '#kpi_history' };
